/**
 * Rax Main Entry Point
 *
 * Initializes the Rax application and loads all components.
 */

// Import styles
import "./ui/styles/rax-theme.js";
// Import API client
import "./api/rax-api.js";
// Import all components
import "./ui/components/index.js";

// Log initialization
console.log("[Rax] ⚡ Initializing...");

// Wait for DOM ready
document.addEventListener("DOMContentLoaded", () => {
  console.log("[Rax] ⚡ DOM ready, app loading...");
});

// Export for external use
export * from "./api/rax-api.js";
export * from "./ui/components/index.js";
